<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a href="/admin/adminInvoice/">Invoices</a></li>
      <li class="breadcrumb-item active" aria-current="page">Payment Processing</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <h2 class="text-black mb-3"></h2>
        <div class="inner-box">
          <div class="form-radio">
            <input type="radio" id="thirdParty" [(ngModel)]="paymentType" [ngModelOptions]="{standalone: true}" required
                   value="THIRD_PARTY" name="type">
            <label for="thirdParty">Pay Using</label>
          </div>

          <div style="padding: 10px 250px;margin-top: 26px;"  [hidden]="paymentType === 'MANUAL'">
            <a id="Button" (click)="pay()"> <img referrerpolicy="origin" src = "https://badges.razorpay.com/badge-dark.png " style = "height: 67px;width: 165px;" alt = "Razorpay | Payment Gateway | Neobank"></a>
          </div>
          <br><br>

          <!--<div class="form-radio">
            <p>Debit Card</p>
          </div>
          <div class="form-radio">
            <p>Credit Card</p>
          </div>
          <div class="form-radio">
          <p>Wallet</p>
        </div>-->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2 class="text-white mb-3"></h2>
        <div class="inner-box">
          <div class="form-radio">
            <input type="radio" id="manualPayment" [(ngModel)]="paymentType" [ngModelOptions]="{standalone: true}" required value="MANUAL" name="type">
            <label for="manualPayment">Manual Payment</label>
          </div>
          <div class="row mt-3" [hidden]="paymentType !== 'MANUAL'">
            <div class="col">
              <h2 class="text-black mb-3 review">Shift Bank Details :</h2>
              <div>
                <label class="text-black"><i>Cheque / Demand Draft should be issued in the Name of </i><br/>
                  <span><b>Shift Logistics Pvt. ltd</b></span> </label>
              </div><br>
              <h2 class="text-black mb-3 review">RTGS / NEFT can be done for the Account Details Below :</h2>
              <div>
                <label class="text-black"><b>Bank Name : </b><span class="ml-1">State Bank of India</span></label><br>
                <label class="text-black"><b>Account Number : </b>11332415251</label><br>
                <label class="text-black"><b>Branch : </b>Attapur</label><br>
                <label class="text-black"><b>IFSC Code : </b>SBIN0012720</label><br>
              </div>
            </div>
          </div>

          <div class="mt-3 required" [hidden]="paymentType !== 'MANUAL'">
            <label class="control-label"><b>Select Payment Type</b></label>
            <ng-select style="height: 38px" id="paymentMode" [(ngModel)]="selectedPaymentMode" (click)="reset()"
                       [ngModelOptions]="{standalone: true}"
                       required
                       [ngClass]="{'service-error':statusText1}"
                       (blur)="blurPayment()"
                       [ngClass]="{'is-invalid':statusText1}"
                       [items]="paymentMode"
                       bindLabel="config"
                       placeholder="Payment Mode">
            </ng-select>
            <div id="statusText1" class="invalid-feedback d-block mb-3" [hidden]="!statusText1">{{statusText1}}</div>
          </div>

          <div class="mt-3" [hidden]="selectedPaymentMode.config !== 'CHEQUE'">
            <label for="chequeNum">Cheque Number</label>
            <div class="form-group">
              <input type="text" id="chequeNum" [(ngModel)]="chequeNum" (click)="reset()"
                     [ngModelOptions]="{standalone: true}" class="form-control" required>
            </div>
            <div id="statusText2" class="invalid-feedback d-block mb-3" [hidden]="!statusText2">{{statusText2}}</div>
          </div>
          <div class="mt-3" [hidden]="selectedPaymentMode.config !== 'BANK_TRANSFER'">
            <label for="refNum">Reference Number</label>
            <div class="form-group">
              <input type="text" id="refNum" [(ngModel)]="refNum" (click)="reset()"
              [ngModelOptions]="{standalone: true}" class="form-control" required>
            </div>
            <div id="statusText3" class="invalid-feedback d-block mb-3" [hidden]="!statusText3">{{statusText3}}</div>
          </div>
          <div class="mt-3" [hidden]="selectedPaymentMode.config !== 'CASH'">
            <label for="receiptNum">Receipt Number</label>
            <div class="form-group">
              <input type="text" id="receiptNum" [(ngModel)]="receiptNum" (click)="reset()"
                     [ngModelOptions]="{standalone: true}" class="form-control" required>
            </div>
            <div id="statusText4" class="invalid-feedback d-block mb-3" [hidden]="!statusText4">{{statusText4}}</div>
          </div>
          <div class="row mt-3">
            <div class="col" [hidden]="paymentType !== 'MANUAL'">
              <label><b>Amount :</b><span class="ml-1">{{payMent.totalAmount}}/-</span></label>
            </div>
          </div>
          <div class="col-md-5">
            <label>&nbsp;</label>
            <div class="upload-box" style="height:87px!important;width:120px!important;" *ngIf="!imageUrl">
              <input type="file" [(ngModel)]="imageUrl" (change)="loadImage($event)" [ngModelOptions]="{standalone: true}">
              <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
              </svg>
              <div>upload Image</div>
            </div>
            <div class="upload-box mt-2" *ngIf="imageUrl">
              <img class="shift-uploaded-img shift-image" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"  width="250" height="250" />
              <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
              <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="150" height="150" />
              <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="100" height="100" />
              <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="50" height="50" />

              <div class="overly">
                <button class="btn">
                  <input type="file" [(ngModel)]="imageUrl" (change)="loadImage($event)">
                  <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>Upload</button>
                <button class="btn" (change)="ignoreImage()">
                  <input type="file" (change)="ignoreImage()">
                  <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>Remove</button>
              </div>
            </div>
            <div id="statusText5" class="invalid-feedback d-block mb-3" [hidden]="!statusText5">{{statusText5}}</div>
          </div>

          <div class="mt-3" [hidden]="paymentType !== 'MANUAL'">
            <div class="required">
              <label for="description" style="font-size:14px">Comments</label>
              <textarea id="description" [(ngModel)]="comments" rows="4"  maxlength="250" class="form-control" [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>

        </div>

        <!--<div class="row text-right mt-3">
          <div class="col">
            <button [hidden]="user.role == 'ROLE_ADMIN'" type="button" routerLink="/admin/invoices" class="btn btn-cancel">Close</button>
            <button [hidden]="user.role !== 'ROLE_ADMIN'" type="button" routerLink="/admin/adminInvoice" class="btn btn-cancel">Close</button>
            <button type="button" (click)="processingPayment()" class="btn btn-orange ml-2">Confirm</button>
          </div>
        </div>-->
      </div>
    </div>
  </form>
  <div class="row mt-4">
    <div class="form-btn-section" style="margin-left: -15px;">
    <div class="col-12 text-right">
      <button [hidden]="user.role == 'ROLE_ADMIN'" type="button" routerLink="/admin/invoices" class="btn btn-cancel">Close</button>
      <button [hidden]="user.role !== 'ROLE_ADMIN'" type="button" routerLink="/admin/adminInvoice" class="btn btn-cancel">Close</button>
      <button type="button" (click)="processingPayment()" class="btn btn-orange ml-2">Confirm</button>
    </div>
  </div>
  </div>
  <br><br><br>
</section>

<div class="modal fade style-modal" id="upLoadImage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content modal-content-shift">
      <div class="modal-body">
        <div class="form-group btn-upload">
          <label for="file" class="shift-upload-img" [ngStyle]="{'background-image':'url('+ productImage +')', 'background-position': 'center', 'background-size': 'cover'}" style="width:234px; height:200px"></label>
          <input type="file" class="form-control-file"  (change)="loadImage($event)" id="file"  accept="image/*">
        </div>
        <div class="text-right mt-3">
          <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="ignoreImage()">Cancel</button>
          <button type="button" (click)="submitImage()" class="btn btn-cancel-okay ml-1 text-white"  data-toggle="modal" data-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
